// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const ednoFestData = createApi({
  reducerPath: "ednoFestApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getRecentEvents: builder.query({
      query: () => `recent_event`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getAllEvents: builder.query({
      query: () => `all_event`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getEventCategories: builder.query({
      query: () => `event_category`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getEventCategoriesWise: builder.query({
      query: (category_id) => ({
        url: `event_category_wise`,
        params: {
          category_id,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRecentEventsQuery,
  useGetAllEventsQuery,
  useGetEventCategoriesQuery,
  useGetEventCategoriesWiseQuery,
} = ednoFestData;
